import React from "react";
import Lottie from "react-lottie";
import animation from "../../animations/loading.json";

interface AnimationProps {
  width?: number;
  height?: number;
  options?: any;
  speed?: number;
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animation
};

const Loading: React.FC<AnimationProps> = props => {
  const {
    width = 60,
    height = 60,
    options = defaultOptions,
    speed = 1
  } = props;
  return (
    <Lottie
      options={options}
      speed={speed}
      width={`${width}px`}
      height={`${height}px`}
      isClickToPauseDisabled
    />
  );
};

export default Loading;
